import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import { Link, Navigate, useLocation } from "react-router-dom";
import { navigate } from "@reach/router";
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';
import { numberWithSpaces } from '../utilities/OtherUtilities.js';

// import components
import RoundButton from '../components/RoundButton.js';
import NewSubmissionFormTile from '../tiles/NewSubmissionFormTile.js';

// import assets
import btn_back_gray from '../assets/btn_back_gray.png';

/*
    This NewSubmission class serves for creating new Submissions, but also for editing existing Submissions
*/
class NewSubmission extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);

        this.state = {
            redirectTo: null,
            mainSubmissionsId: 0,
            listOfCategories: ([]),
            listOfCategoriesValues: ([]),
            listOfCategoriesValuesPrevSubm: ([]),
            listOfNatOrg: ([{id:1, label: "Organization 1"},{id:1, label: "Organization 2"},{id:1, label: "Organization 3"}]),
            listOfStatType: ([{id:1, label: "Type 1"},{id:1, label: "Type 2"},{id:1, label: "Type 3"}]),
            listOfPeriods: ([{id:1, label: "Year 1"},{id:2, label: "Year 2"},{id:3, label: "Year 3"}]),
            listOfCurrencies: ([{id: 1, label: "Currency 1"},{id: 2, label: "Currency 2"},{id: 3, label: "Currency 3"}]),
            selectedStatType: 0,
            selectedYear: 0,
            selectedCurrency: 0,
            selectedNatOrg: 0,
            showStep: 1,
            selectedDocument: "",
            savedDocument: "",
        }
    }

    componentDidMount(){
        this.setState({ redirectTo: null });
        //this.setActualSection("submissions");

        const { tile } = Object.fromEntries(new URLSearchParams(window.location.search));
        const pathname = this.props.location.pathname;
        var id = pathname.substring(pathname.lastIndexOf("/")+1);
        if(id.includes("?")){ id = id.substring(0, id.indexOf("?")); }
        if(Number.isInteger(Number(id)))this.setState({ mainSubmissionsId: parseInt(id) });

        this.loadData();
    }

    loadData = async () => {
        await this.loadNatOrg();
        await this.loadStatTypes();
        await this.loadCurrencyTypes();
        await this.loadPeriods();
        await this.loadCategoryTypes();

        // if editing existing submission then load the existing submission data
        if(this.state.mainSubmissionsId != 0){
            await this.loadExistingSubmission();
        }
    }

    loadNatOrg = () => {
        Axios.get('/api/nt_org/get').then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var natOrgList = [];
            for(let oneRow of response.data.result){ natOrgList.push({"id":oneRow.id, "label": oneRow.label}); }
            this.setState({ listOfNatOrg: natOrgList });
        });
    }

    loadStatTypes = () => {
        Axios.get('/api/stmt_tp/get').then(response => {
            this.setState({ listOfStatType: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var statTpList = [];
            for(let oneRow of response.data.result){ statTpList.push({"id":oneRow.id, "label": oneRow.label}); }
            this.setState({ listOfStatType: statTpList });
        });
    }

    loadPeriods = () => {
        Axios.get('/api/period/get').then(response => {
            this.setState({ listOfPeriods: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            //var periodsList = [];
            //for(let oneRow of response.data.result){ periodsList.push({"id":oneRow.id, "label": oneRow.label}); }
            this.setState({ listOfPeriods: response.data.result });
        });
    }

    loadCurrencyTypes = () => {
        Axios.get('/api/ccy/get').then(response => {
            this.setState({ listOfCurrencies: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var currenciesList = [];
            for(let oneRow of response.data.result){ currenciesList.push({"id":oneRow.id, "label": oneRow.iso_code}); }
            this.setState({ listOfCurrencies: currenciesList });
        });
    }

    loadCategoryTypes = () => {
        Axios.get('/api/ctg/get').then(response => {
            this.setState({ listOfCategories: [] });
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            var categoryTypesList = response.data.result;

            // filter just categories for specific statement type
            categoryTypesList = categoryTypesList.filter(item => item.stmt_tp_id == this.state.selectedStatType);

            categoryTypesList = categoryTypesList.map(item => {
                return {
                    ...item,
                    amount_prev_year: 0,
                    amount: 0,
                    explanation: "",
                    var_explanation: "",
                    is_open: true,
                }
            });
            this.setState({ listOfCategories: categoryTypesList });

            // if editing existing submission then load values for all categories
            if(this.state.mainSubmissionsId != 0 && categoryTypesList.length > 0 && this.state.listOfCategoriesValues.length > 0){

                categoryTypesList = categoryTypesList.map(item => {
                    return {
                        ...item,
                        amount_prev_year: this.getPrevAmtByCtgId(item.id),
                        amount: this.getAmtByCtgId(item.id),
                        explanation: this.getCmntByCtgId(item.id),
                        var_explanation: this.getExplByCtgId(item.id),
                        is_open: true,
                    }
                });
                this.setState({ listOfCategories: categoryTypesList });

            }

        });
    }

    loadExistingSubmission = async () => {
        Axios.get('/api/subm/get/'+this.state.mainSubmissionsId).then(response => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            this.setState({ selectedNatOrg: response.data.result[0].nt_org_id });
            this.setState({ selectedYear: response.data.result[0].period_id });
            this.setState({ selectedStatType: response.data.result[0].stmt_tp_id });
            this.setState({ selectedCurrency: response.data.result[0].ccy_id });
            if(response.data.result[0].prev_subm_id){
                // if there is submission from previous year, then load the values
                this.setState({ prev_subm_id: response.data.result[0].prev_subm_id });

                Axios.get('/api/subm_item/get?subm_id='+response.data.result[0].prev_subm_id).then(response => {
                    if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
                    this.setState({ listOfCategoriesValuesPrevSubm: response.data.result });
                    this.loadCategoryTypes();
                });
            }

            // here I am saving values of the categories, but I need to also load specific categories for this specific submission
            // those data are now loading from /api/subm_item/get?subm_id=ID?
            //this.setState({ listOfCategoriesValues: response.data.result });
            //this.loadCategoryTypes();

            // load file
            this.setState({ savedDocument: "" });
            Axios.get('/api/file/load?subm_id='+this.state.mainSubmissionsId+"&file_prefix=subm").then(response => {
                //if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
                if(response.data.stat && response.data.stat == "ERR"){
                    // document was not loaded - probably was not uploaded for this submission
                }
                else {
                    this.setState({ savedDocument: response.data });
                }
            });

        });

        Axios.get('/api/subm_item/get?subm_id='+this.state.mainSubmissionsId).then(response => {
            // here I am saving values of the categories, but I need to also load specific categories for this specific submission
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
            this.setState({ listOfCategoriesValues: response.data.result });
            this.loadCategoryTypes();
        });
    }

    componentDidUpdate(prevProps){
        if(this.props.location.pathname !== prevProps.location.pathname){
            // reload tiles
        }
    }

    onSubmitClicked = () => {
        //this.props.openAlertMessageTwoActions("After submitting it is not possible to edit submission. Do you really want to submit?","Cancel","Submit",this.submitSubmission);
        // for now I would just do the action, because now we dont do difference between saving draft and submitting
        this.submitSubmission();
    }

    submitSubmission = () => {
        var StmtTpId = this.state.selectedStatType;
        var PeriodId = this.state.selectedYear;
        var NtOrgId = this.state.selectedNatOrg;
        var CcyId = this.state.selectedCurrency;
        var StatId = 1; // pending=1, approved=2, rejected=3, submitted=4
        var SelectedDocument = this.state.selectedDocument;

        //var Item = [{"CtgId":25, "Amt": 9990000, "Cmnt": "Velké přijmy", "Expl": "Bývalo lépe"}]; // this is example
        var Item = []

        if(this.checkIfInputsAreCorrect(StmtTpId, PeriodId, NtOrgId, CcyId, StatId, Item, SelectedDocument) == 0)return;

        for(let oneRow of this.state.listOfCategories){
            Item.push({"CtgId":oneRow.id, "Amt": oneRow.amount, "Cmnt": oneRow.explanation, "Expl": oneRow.var_explanation});
        }

        // now I should have everything ready to do API INS or UPD
        var url = "/api/subm/ins";
        if(this.state.mainSubmissionsId != 0) url = "/api/subm/upd/"+this.state.mainSubmissionsId;
        Axios.post(url, {
            StmtTpId: StmtTpId,
            PeriodId: PeriodId,
            NtOrgId: NtOrgId,
            CcyId: CcyId,
            StatId: StatId,
            Item: Item,
        }).then((response) => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }

            if(Number.isInteger(Number(response.data.msg.id)) && SelectedDocument != ""){

                // now I will upload file if there is some
                var submissionID = Number(response.data.msg.id);
                Axios.post("/api/file/upload", {
                    SubmId: submissionID,
                    FilePrefix: "subm",
                    content: SelectedDocument,
                }).then((response) => {
                    if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessageTwoActions) == 1){ return; }
                    //alert(JSON.stringify(response.data));
                });

            }

            //alert(JSON.stringify(response.data.msg.id));

            this.setState({ redirectTo: "/Submissions" });
        });
    }

    getPrevAmtByCtgId(ctg_id) {
        for(let oneRow of this.state.listOfCategoriesValuesPrevSubm){
           if(oneRow.ctg_id == ctg_id && Number.isInteger(Number(oneRow.amt)))return parseInt(oneRow.amt);
        }
        return 0;
    }

    getAmtByCtgId(ctg_id) {
        for(let oneRow of this.state.listOfCategoriesValues){
           if(oneRow.ctg_id == ctg_id && Number.isInteger(Number(oneRow.amt)))return parseInt(oneRow.amt);
        }
        return 0;
    }

    getCmntByCtgId = (ctg_id) => {
        for(let oneRow of this.state.listOfCategoriesValues){
            if(oneRow.ctg_id == ctg_id)return oneRow.cmnt;
        }
        return "";
    }

    getExplByCtgId = (ctg_id) => {
        for(let oneRow of this.state.listOfCategoriesValues){
            if(oneRow.ctg_id == ctg_id && true)return oneRow.expl;
        }
        return "";
    }

    getCurrencyName = () => {
        for(let oneRow of this.state.listOfCurrencies){
            if(oneRow.id == this.state.selectedCurrency)return oneRow.label;
        }
    }

    checkIfInputsAreCorrect = (StmtTpId, PeriodId, NtOrgId, CcyId, StatId, Item, SelectedDocument) => {
        if(NtOrgId == 0 || NtOrgId == ""){
            this.props.openAlertMessageTwoActions("Please fill the National Organization field.","OK","",null);
            return 0;
        }
        if(PeriodId == 0 || PeriodId == ""){
            this.props.openAlertMessageTwoActions("Please fill the Year field.","OK","",null);
            return 0;
        }
        if(StmtTpId == 0 || StmtTpId == ""){
            this.props.openAlertMessageTwoActions("Please fill the Statement Type field.","OK","",null);
            return 0;
        }
        if(CcyId == 0 || CcyId == ""){
            this.props.openAlertMessageTwoActions("Please fill the Currency field.","OK","",null);
            return 0;
        }
        /*if(SelectedDocument == "" && this.state.savedDocument == ""){
            this.props.openAlertMessageTwoActions("Please include PDF document.","OK","",null);
            return 0;
        }*/
        return 1;
    }

    onSaveDraft = () => {
        // right now we are not able to save it as draft so we just save it normally
        this.submitSubmission();
    }

    onCancel = () => {
        this.props.openAlertMessageTwoActions("Are you sure you want to cancel? You will lose all unsaved data.","Continue editing","Yes, Cancel",this.goBack);
    }

    goBack = () => {
        this.setState({ redirectTo: -1 });
    }

    setListOfCategories = (newList) => {
        this.setState({ listOfCategories: newList });
    }

    toBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    fileIsSelected = async (event) => {
        const fileUploaded = event.target.files[0];
        if(fileUploaded.size > 10000000){
            this.props.openAlertMessageTwoActions("Error! Maximum size of file is 10 MB.","OK","",null);
            return;
        }
        var base64 = await this.toBase64(fileUploaded);
        //var prefix = fileUploaded.name.substring(fileUploaded.name.lastIndexOf(".")+1);

        this.setState({ selectedDocument: base64 });
    };

    askToDeleteDocument = () => {
        this.props.openAlertMessageTwoActions("Are you sure you want to delete document from this submission? This action cannot be reversed.","Cancel","Delete",this.deleteDocument);
    }

    deleteDocument = () => {
        Axios.post('/api/file/delete', {
            FilePrefix: "subm",
            SubmId: this.state.mainSubmissionsId,
        }).then((response) => {
            if(checkForErrorsInRequest(response.data.msg, this.props.openAlertMessage) == 1){ return; }
            this.loadExistingSubmission();
        });
    }

    render() {
        if (this.state.redirectTo) {
            return <Navigate to={this.state.redirectTo} />
        }
        return(
            <div className="verticalStack flex" style={{height: "calc(100vh - 80px)", overflowY: "scroll"}}>
                <div className="horizontalStackCenter universalTableListingBar">
                    <div className="horizontalStackCenter onHoverToOrange clickable" onClick={() => this.setState({ redirectTo: -1 })}>
                        <img src={btn_back_gray} style={{height: 14, marginRight: 7}} />
                        <span className="fontPoppinsRegular13Gray" style={{whiteSpace: "nowrap"}}>{"Return to Previous Page"}</span>
                    </div>
                </div>

                <div className="horizontalStack">

                    <div className="verticalStack flex">

                        <div className="universalTile" style={{marginLeft: 20, marginRight: 10}}>
                            <span className="fontPoppinsSemiBold15">New Submission</span>

                            <div className="horizontalStack" style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20, paddingTop: 20, paddingBottom: 20}}>

                                <div className="verticalStack" style={{paddingLeft: 20, paddingRight: 0}}>
                                    <span className="fontPoppinsRegular13 oneLineText" style={{marginBottom: 5}}>National Organization:*</span>
                                    <select className="universalTextInput topMenuSelectBox" name="nat_org" id="nat_org" style={{}} value={this.state.selectedNatOrg} onChange={e => this.setState({ selectedNatOrg: e.target.value })} disabled={this.state.mainSubmissionsId != 0 ? "disabled" : ""}>
                                        <option value=""></option>
                                        {this.state.listOfNatOrg.map(function (item) {
                                            return (
                                               <option value={item.id}>{item.label}</option>
                                            )
                                        }.bind(this))}
                                    </select>
                                </div>

                                <div className="verticalStack" style={{paddingLeft: 20, paddingRight: 0}}>
                                    <span className="fontPoppinsRegular13 oneLineText" style={{marginBottom: 5}}>Year:*</span>
                                    <select className="universalTextInput topMenuSelectBox" name="year" id="year" style={{width: 100}} value={this.state.selectedYear} onChange={e => this.setState({ selectedYear: e.target.value })} disabled={this.state.mainSubmissionsId != 0 ? "disabled" : ""}>
                                        <option value=""></option>
                                        {this.state.listOfPeriods.map(function (item) {
                                            return (
                                               <option value={item.id}>{item.label}</option>
                                            )
                                        }.bind(this))}
                                    </select>
                                </div>

                                <div className="verticalStack" style={{paddingLeft: 20, paddingRight: 0}}>
                                    <span className="fontPoppinsRegular13 oneLineText" style={{marginBottom: 5}}>Statement Type:*</span>
                                    <select className="universalTextInput topMenuSelectBox" name="stat_type" id="stat_type" value={this.state.selectedStatType} onChange={e => {this.setState({ selectedStatType: e.target.value });this.loadCategoryTypes();}} disabled={this.state.mainSubmissionsId != 0 ? "disabled" : ""}>
                                        <option value=""></option>
                                        {this.state.listOfStatType.map(function (item) {
                                            return (
                                               <option value={item.id}>{item.label}</option>
                                            )
                                        }.bind(this))}
                                    </select>
                                </div>

                                <div className="verticalStack" style={{paddingLeft: 20, paddingRight: 0}}>
                                    <span className="fontPoppinsRegular13 oneLineText" style={{marginBottom: 5}}>Currency:*</span>
                                    <select className="universalTextInput topMenuSelectBox" name="currency" id="currency" style={{width: 100}} value={this.state.selectedCurrency} onChange={e => this.setState({ selectedCurrency: e.target.value })} disabled={this.state.mainSubmissionsId != 0 ? "disabled" : ""}>
                                        <option value=""></option>
                                        {this.state.listOfCurrencies.map(function (item) {
                                            return (
                                                <option value={item.id}>{item.label}</option>
                                            )
                                        }.bind(this))}
                                    </select>
                                </div>

                                <div className="verticalStack" style={{paddingLeft: 20, paddingRight: 20}}>
                                    <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Document (PDF):</span>
                                    {this.state.mainSubmissionsId == 0 || this.state.savedDocument == "" ? <input type="file" id="document" name="document" accept=".pdf" onChange={(event) => this.fileIsSelected(event)} style={{width: 200}} /> : null }
                                    {this.state.mainSubmissionsId != 0 && this.state.savedDocument != "" ?
                                        <span className="fontPoppinsRegular13DarkGray">
                                            <a download={"submission_"+this.state.natOrgLabel+"_"+this.state.periodLabel} href={this.state.savedDocument}><span className="fontPoppinsRegular13Gray textLinkHover">Download</span></a>
                                            <span className="clickable onHoverUnderline" style={{color: "var(--delete-logout-red)", marginLeft: 10}} onClick={() => this.askToDeleteDocument()}>Delete</span>
                                        </span>
                                    : null }
                                </div>

                                <div className="flex"/>

                                {/* some buttons have different "texts" for INSERTING then for UPDATING */}
                                <div className="horizontalStackCenter" style={{display: this.state.showStep == 1 ? "" : "none", marginRight: 20}}>
                                    <RoundButton title={"Next Step"} className={"roundButtonOrange"} onClick={() => this.setState({ showStep: 2 })} whiteText={true} />
                                    <div style={{width: 20, height: 20}}></div>
                                    {this.state.mainSubmissionsId == 0 ? <RoundButton title={"Save Draft"} className={"roundButtonGray"} onClick={this.onSaveDraft} whiteText={true} /> : null}
                                    {this.state.mainSubmissionsId != 0 ? <RoundButton title={"Save Changes"} className={"roundButtonGray"} onClick={this.onSubmitClicked} whiteText={true} /> : null}
                                    <div style={{width: 20, height: 20}}></div>
                                    {/*<RoundButton title={"Cancel"} className={"roundButtonGray"} onClick={this.onCancel} whiteText={true} />*/}
                                </div>

                                {/* some buttons have different "texts" for INSERTING then for UPDATING */}
                                <div className="horizontalStackCenter" style={{display: this.state.showStep == 2 ? "" : "none", marginRight: 20}}>
                                    <RoundButton title={"Prev Step"} className={"roundButtonGray"} onClick={() => this.setState({ showStep: 1 })} whiteText={true} />
                                    <div style={{width: 20, height: 20}}></div>
                                    {this.state.mainSubmissionsId == 0 ? <RoundButton title={"Submit"} className={"roundButtonOrange"} onClick={this.onSubmitClicked} whiteText={true} /> : null}
                                    {this.state.mainSubmissionsId == 0 ? <div style={{width: 20, height: 20}}></div> : null }
                                    {this.state.mainSubmissionsId == 0 ? <RoundButton title={"Save Draft"} className={"roundButtonGray"} onClick={this.onSaveDraft} whiteText={true} /> : null}
                                    {this.state.mainSubmissionsId != 0 ? <RoundButton title={"Save Changes"} className={"roundButtonOrange"} onClick={this.onSubmitClicked} whiteText={true} /> : null}
                                    <div style={{width: 20, height: 20}}></div>
                                    {/*<RoundButton title={"Cancel"} className={"roundButtonGray"} onClick={this.onCancel} whiteText={true} />*/}
                                </div>
                            </div>

                        </div>

                        {/* if statement type was chosen then show form for specific statement type */}
                        {this.state.selectedStatType == 0 ? <div className="universalLeftTileWithTable" style={{marginTop: 20, marginBottom: 20}}><span className="fontPoppinsRegular13">Statement Type was not specified</span></div> : null }
                        {this.state.selectedStatType != 0 ? <NewSubmissionFormTile showStep={this.state.showStep} statTpId={this.state.selectedStatType} listOfCategories={this.state.listOfCategories} setListOfCategories={this.setListOfCategories} currency={this.getCurrencyName()} /> : null }

                    </div>

                </div>
            </div>
        );
    }
}

const withLocation = Component => props => {
    const location = useLocation();

    return <Component {...props} location={location} />;
};

export default withLocation(NewSubmission);